import React from 'react';
import AgenticAIApp from './AgenticAIApp';
import { useAgenticAI } from '../../context/AgenticAIContext';
import './AgenticAIDrawer.css';

const AgenticAIDrawer = () => {
    const { isOpen, isMaximized, closeDrawer, toggleMaximize } = useAgenticAI();

    return (
        <>
            {isOpen && <div className="agentic-ai-drawer-overlay" onClick={closeDrawer} />}
            <div className={`agentic-ai-drawer${isOpen ? ' open' : ''}${isMaximized ? ' maximized' : ''}`}>
                <div className="agentic-ai-page-wrapper">
                    <AgenticAIApp onClose={closeDrawer} isMaximized={isMaximized} onToggleMaximize={toggleMaximize} />
                </div>
            </div>
        </>
    );
};

export default AgenticAIDrawer;
